// extracted by mini-css-extract-plugin
export default {"header":"LeadHeader_header__UuEPX","headerIcon":"LeadHeader_headerIcon__aRBnB"};